import React from 'react';

import StaticTabs from '../../../../components/tabs/StaticTabs';

function renderTabsBlock(data, index, renderStaticSection) {
  const {
          CONTENT: content,
          LABEL:   label,
          NAV:     nav,
        } = data;

  return (
    <section key={index} className={'withTabs'}>
      <div className={'container'}>
        <StaticTabs label={label} nav={nav}>
          {content.map((tab, t) => (
            <div key={t}>
              {tab.map((block, b) => renderStaticSection(block, b))}
            </div>
          ))}
        </StaticTabs>
      </div>
    </section>
  );
}

export default renderTabsBlock;